import { combineReducers } from '@reduxjs/toolkit';
import availableAssigneesSlice from './availableAssignees/availableAssigneesSlice';
import bulkAssignSlice from './bulkAssignSlice';

export default combineReducers({
  availableAssignees: availableAssigneesSlice,
  value: bulkAssignSlice,
});
